import React from 'react'
import Switch, { SwitchProps } from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'

import { COLORS } from 'styles'

const TRACK_OFF = '#C6C6C6'

const ToggleSwitch = withStyles({
  root: {
    width: 44,
    height: 24,
    padding: 0,
    overflow: 'hidden',
  },
  switchBase: {
    padding: 2,
    color: COLORS.WHITE,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&$checked': {
      transform: 'translateX(20px)',
      color: COLORS.WHITE,
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& + $track': {
        backgroundColor: COLORS.SUCCESS,
        opacity: 1,
      },
    },
  },
  colorPrimary: {
    '&$checked': {
      color: COLORS.WHITE,
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& + $track': {
        backgroundColor: COLORS.SUCCESS,
        opacity: 1,
      },
    },
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: 'none',
  },
  track: {
    borderRadius: 12,
    backgroundColor: TRACK_OFF,
    opacity: 1,
  },
  checked: {},
})((props: SwitchProps) => <Switch disableRipple color="primary" {...props} />)

export { ToggleSwitch }
